import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  stars: 5,
  text: '"De 4 despertares nocturnos a ninguno en 12 días. Como directora de empresa, necesitaba un sistema, no consejos. B.E.BE 365 me devolvió mis noches y mi productividad."',
  initials: 'MG',
  name: 'María G.',
  location: 'Ciudad de México'
}, {
  stars: 5,
  text: '"La sección de estimulación visual es increíble. Mi pediatra no puede creer la coordinación que tiene Mateo a los 5 meses. El protocolo funciona exactamente como promete."',
  initials: 'VP',
  name: 'Valentina P.',
  location: 'Buenos Aires, Argentina'
}, {
  stars: 5,
  text: '"El único protocolo que mi esposo y yo aplicamos juntos sin conflictos. Salvó la comunicación de nuestra pareja y el sueño de toda la familia. Vale 10 veces lo que cuesta."',
  initials: 'CS',
  name: 'Carolina S.',
  location: 'Bogotá, Colombia'
}];
export function TestimonialsSection() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const handleScroll = () => {
    const container = scrollRef.current;
    if (!container) return;
    const scrollLeft = container.scrollLeft;
    const cardWidth = container.offsetWidth * 0.85;
    const index = Math.round(scrollLeft / cardWidth);
    setActiveIndex(Math.min(index, testimonials.length - 1));
  };
  const scrollToIndex = (index: number) => {
    const container = scrollRef.current;
    if (!container) return;
    const cardWidth = container.offsetWidth * 0.85;
    container.scrollTo({
      left: cardWidth * index,
      behavior: 'smooth'
    });
    setActiveIndex(index);
  };
  return <section id="testimonials" className="bg-[#FAF7F2] py-10 md:py-12" data-id="element-358">
      <div className="max-w-[900px] mx-auto px-5" data-id="element-359">
        <div className="text-center mb-2.5" data-id="element-360">
          <span className="inline-block bg-[rgba(183,110,121,0.1)] text-[#B76E79] text-xs tracking-widest uppercase px-4 py-1.5 rounded-full font-sans font-bold" data-id="element-361">
            Resultados Reales
          </span>
        </div>

        <h2 className="text-3xl md:text-4xl text-[#3D2B1F] mb-4 leading-tight text-center" data-id="element-362">
          Lo que dicen los Arquitectos B.E.BE
        </h2>

        <p className="text-lg text-[#6B4C3B] text-center max-w-[650px] mx-auto mb-8 italic" data-id="element-363">
          Padres reales. Resultados reales.
        </p>
      </div>

      {/* Horizontal Carousel */}
      <div ref={scrollRef} onScroll={handleScroll} className="flex gap-4 overflow-x-auto snap-x snap-mandatory scroll-smooth px-5 md:px-[calc(50%-430px)] pb-4 no-scrollbar" style={{
      scrollbarWidth: 'none',
      msOverflowStyle: 'none'
    }} data-id="element-364">
        {testimonials.map((testimonial, idx) => <motion.article key={idx} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.1
      }} className="bg-white rounded-2xl p-6 md:p-7 shadow-md border border-[rgba(183,110,121,0.1)] snap-center flex-shrink-0 w-[85%] md:w-[320px]" data-id="element-365">
            <div className="text-[#C9A96E] text-lg mb-3.5" aria-label={`${testimonial.stars} de 5 estrellas`} role="img" data-id="element-366">
              {'★'.repeat(testimonial.stars)}
            </div>
            <p className="text-base text-[#3D2B1F] italic leading-relaxed mb-4" data-id="element-367">
              {testimonial.text}
            </p>
            <div className="flex items-center gap-3" data-id="element-368">
              <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#B76E79] to-[#C9A96E] flex items-center justify-center text-white font-bold text-base flex-shrink-0" aria-hidden="true" data-id="element-369">
                {testimonial.initials}
              </div>
              <div data-id="element-370">
                <div className="text-base font-bold text-[#3D2B1F]" data-id="element-371">
                  {testimonial.name}
                </div>
                <div className="text-sm text-gray-400 font-sans" data-id="element-372">
                  {testimonial.location}
                </div>
              </div>
            </div>
          </motion.article>)}
      </div>

      {/* Dot indicators */}
      <div className="flex justify-center gap-2 mt-4 md:hidden" data-id="element-373">
        {testimonials.map((_, idx) => <button key={idx} onClick={() => scrollToIndex(idx)} className={`w-2 h-2 rounded-full transition-all border-none cursor-pointer ${activeIndex === idx ? 'bg-[#B76E79] w-6' : 'bg-[#B76E79]/30'}`} aria-label={`Ir al testimonio ${idx + 1}`} data-id="element-374" />)}
      </div>
    </section>;
}